import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appConfig: null,
    uuid: null,
    wxid: null,
    memberCoupon: null,
    timsAccount: null,
    lastOrder: null,
  },
  mutations: {
    SET_APP_CONFIG(state, config) {
      state.appConfig = config
    },
    SET_UUID(state, uuid) {
      state.uuid = uuid
    },
    SET_WXID(state, wxid) {
      state.wxid = wxid
    },
    SET_MEMBER_COUPON(state, coupon) {
      state.memberCoupon = coupon
    },
    SET_TIMS_ACCOUNT(state, account) {
      state.timsAccount = account
    },
    SET_LAST_ORDER(state, order) {
      state.lastOrder = order
    },
    CLEAR_ALL(state) {
      state.appConfig = null
      state.uuid = null
      state.wxid = null
      state.memberCoupon = null
      state.timsAccount = null
    },
  },
  actions: {
    setAppConfig({ commit }, config) {
      commit('SET_APP_CONFIG', config)
    },
    setUuid({ commit }, uuid) {
      commit('SET_UUID', uuid)
    },
    setWxid({ commit }, wxid) {
      commit('SET_WXID', wxid)
    },
    setMemberCoupon({ commit }, coupon) {
      commit('SET_MEMBER_COUPON', coupon)
    },
    setTimsAccount({ commit }, account) {
      commit('SET_TIMS_ACCOUNT', account)
    },
    setLastOrder({ commit }, order) {
      commit('SET_LAST_ORDER', order)
    },
    clearSession({ commit }) {
      commit('CLEAR_ALL')
    },
  },
  plugins: [createPersistedState({
    key: 'tims-zizhu',
    paths: ['appConfig', 'uuid', 'wxid', 'memberCoupon', 'timsAccount', 'lastOrder'],
  })],
})
